import * as React from "react";
/**
 * Planner brand logo icon with gradient fills.
 * Replaces the old rocket icon for the Planner agent.
 */ export const PlannerLogo = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 28 28",
        fill: "none",
        "aria-hidden": "true",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M9.94627 18.053C8.82695 19.1722 7.01219 19.1722 5.89288 18.053L1.83949 13.9996C0.720172 12.8803 0.720172 11.0656 1.83948 9.94628L5.89287 5.89294C7.01219 4.77364 8.82695 4.77364 9.94626 5.89294L13.9997 9.94628C15.119 11.0656 15.119 12.8803 13.9997 13.9996L9.94627 18.053Z",
        fill: "url(#planner_paint0)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M9.94627 18.053C8.82695 19.1722 7.01219 19.1722 5.89288 18.053L1.83949 13.9996C0.720172 12.8803 0.720172 11.0656 1.83948 9.94628L5.89287 5.89294C7.01219 4.77364 8.82695 4.77364 9.94626 5.89294L13.9997 9.94628C15.119 11.0656 15.119 12.8803 13.9997 13.9996L9.94627 18.053Z",
        fill: "url(#planner_paint1)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M1.83942 13.9999C2.95876 15.1192 4.77357 15.1192 5.89292 13.9999L18.0535 1.8395C19.1728 0.720171 20.9876 0.720165 22.107 1.83949L26.1605 5.89293C27.2798 7.01225 27.2798 8.82704 26.1604 9.94638L13.9999 22.1068C12.8806 23.2261 11.0657 23.2261 9.9464 22.1068L1.83942 13.9999Z",
        fill: "url(#planner_paint2)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M1.83942 13.9999C2.95876 15.1192 4.77357 15.1192 5.89292 13.9999L18.0535 1.8395C19.1728 0.720171 20.9876 0.720165 22.107 1.83949L26.1605 5.89293C27.2798 7.01225 27.2798 8.82704 26.1604 9.94638L13.9999 22.1068C12.8806 23.2261 11.0657 23.2261 9.9464 22.1068L1.83942 13.9999Z",
        fill: "url(#planner_paint3)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.89279 18.0531C7.01214 19.1724 8.82695 19.1724 9.9463 18.0531L18.0533 9.94619C19.1727 8.82686 20.9875 8.82686 22.1068 9.94618L26.1603 13.9996C27.2797 15.119 27.2797 16.9338 26.1603 18.0531L18.0533 26.16C16.934 27.2793 15.1191 27.2793 13.9998 26.16L5.89279 18.0531Z",
        fill: "url(#planner_paint4)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.89279 18.0531C7.01214 19.1724 8.82695 19.1724 9.9463 18.0531L18.0533 9.94619C19.1727 8.82686 20.9875 8.82686 22.1068 9.94618L26.1603 13.9996C27.2797 15.119 27.2797 16.9338 26.1603 18.0531L18.0533 26.16C16.934 27.2793 15.1191 27.2793 13.9998 26.16L5.89279 18.0531Z",
        fill: "url(#planner_paint5)"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "planner_paint0",
        x1: "7.91951",
        y1: "5.05348",
        x2: "3.33761",
        y2: "14.8418",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#8752E0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#541278"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "planner_paint1",
        x1: "10.0787",
        y1: "12.9921",
        x2: "6.35234",
        y2: "9.33349",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.12172",
        stopColor: "#3D0D59"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#7034B0",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "planner_paint2",
        x1: "20.9009",
        y1: "0.999964",
        x2: "11.6786",
        y2: "23.1208",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#DB45E0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#6C0F71"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "planner_paint3",
        x1: "20.9009",
        y1: "0.999964",
        x2: "11.6786",
        y2: "23.1208",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#DB45E0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.677403",
        stopColor: "#A829AE"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#8F28B3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "planner_paint4",
        x1: "20.5002",
        y1: "9.12453",
        x2: "16.1671",
        y2: "26.9987",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#3DCBFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#00479E"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "planner_paint5",
        x1: "20.7344",
        y1: "9.58677",
        x2: "12.4007",
        y2: "25.8477",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#3DCBFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#4A40D4"
    }))));
